import { ChevronLeft, ChevronRight } from 'lucide-react';

/** 月份切換器（台北時間計費月）— ‹ YYYY-MM ›，未來月停用前進 */
export function MonthPager({ month, onChange }) {
    const shift = (delta) => {
        const [y, m] = month.split('-').map(Number);
        const d = new Date(Date.UTC(y, m - 1 + delta, 1));
        onChange(`${d.getUTCFullYear()}-${String(d.getUTCMonth() + 1).padStart(2, '0')}`);
    };
    const now = new Date(Date.now() + 8 * 3600 * 1000);
    const cur = `${now.getUTCFullYear()}-${String(now.getUTCMonth() + 1).padStart(2, '0')}`;
    const atCurrent = month >= cur;
    return (
        <div className="inline-flex items-center rounded-md border border-cream-300 overflow-hidden">
            <button onClick={() => shift(-1)} className="px-2 py-1.5 text-ink-500 hover:bg-cream-100 transition focus-visible:outline-2 focus-visible:-outline-offset-2 focus-visible:outline-accent-500" aria-label="prev month">
                <ChevronLeft size={14} />
            </button>
            <span className="px-3 py-1.5 font-mono text-sm text-ink-900 tnum border-x border-cream-200 select-none">{month}</span>
            <button onClick={() => shift(1)} disabled={atCurrent} className="px-2 py-1.5 text-ink-500 hover:bg-cream-100 disabled:opacity-30 disabled:cursor-not-allowed transition focus-visible:outline-2 focus-visible:-outline-offset-2 focus-visible:outline-accent-500" aria-label="next month">
                <ChevronRight size={14} />
            </button>
        </div>
    );
}

export function currentMonthTaipei() {
    const now = new Date(Date.now() + 8 * 3600 * 1000);
    return `${now.getUTCFullYear()}-${String(now.getUTCMonth() + 1).padStart(2, '0')}`;
}
